import { Bar, Pie } from "react-chartjs-2";
import ChartDataLabels from 'chartjs-plugin-datalabels';

export const PieChart = ({ chartData, title }) => {
  return (
    <div className="pie-chart">
      <div className="chart-title">
          {title}
      </div>
      <div className="chart-div">
        <Pie
          data={chartData}
          plugins={[ChartDataLabels]}
          options={{
            maintainAspectRatio: false,
            plugins: {
              legend: {
                position: 'left',
                labels: {
                  boxWidth: 18,
                  boxHeight: 18,
                }
              },
              datalabels: {
                formatter: (value, ctx) => {
                  let sum = 0;
                  let dataArr = ctx.chart.data.datasets[0].data;

                  for (let i = 0; i < dataArr.length; i++)
                    sum += dataArr[i];

                  let percents = (value * 100 / sum).toFixed(0);

                  if (percents < 4.0)
                    return "";

                  return percents + "%";
                },
                color: '#fff',
              },
            },
          }}
        />
      </div>
    </div>
  );
};



export const BarChartTime = ({ chartData, title }) => {
  return (
    <div className="bar-chart">
      <div className="chart-title">
          {title}
      </div>
      <div className="chart-div">
        <Bar
          data={chartData}
          plugins={[ChartDataLabels]}
          options={{
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false
              },
              datalabels: {
                formatter: (value, ctx) => {
                  var hour = Math.floor(value);
                  var minutes = (value - hour) * 60;

                  var label = hour + "h";
                  var endLabel = minutes < 10 ? "0" + minutes : minutes;
                  label += endLabel;

                  return label; 
                },
                color: '#fff',
              },
            },
            responsive: true,
            interaction: {
              intersect: false,
            },
            scales: {
              x: {
                stacked: true,
              },
              yAxis: {
                ticks: {
                  min: 0,
                  stepSize: 1,
                  callback: function(value, index, values) {
                    return value + 'h';
                  }
                }
              }
            }
          }}
        />
      </div>
    </div>
  );
};


export const BarChartDifficulty = ({ chartData, title }) => {
  return (
    <div className="bar-chart">
      <div className="chart-title">
          {title}
      </div>
      <div className="chart-div">
        <Bar
          data={chartData}
          options={{
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false
              },
            },
            responsive: true,
            interaction: {
              intersect: false,
            },
            scales: {
              x: {
                stacked: true,
              },
              yAxis: {
                ticks: {
                  min: 0,
                  stepSize: 1,
                  maxTicksLimit: 5
                }
              }
            }
          }}
        />
      </div>
    </div>
  );
};